import * as React from 'react'
import {useTranslation} from 'react-i18next'
import Select from 'react-select'
import DatePickerV2 from '../../../../components/DatePickerV2/DatePickerV2'
import {Selection} from '../../../../components/Selection'
import {TextInputV2} from '../../../../components/TextInputV2'
import {ORDER_STATUS, REGARDING_OPTIONS, SECTOR_OPTIONS} from '../../../../constants'
import {useCities} from '../../../../hooks/useCities'
import {useRegions} from '../../../../hooks/useRegions'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {amandementSelector, setFilterAmandement} from '../../../../redux/slices/amandementSlices'
import {TRowFilter} from '../../../../components/Table/Table'

export const RowFilter = () => {
  const dispatch = useAppDispatch()

  const {t} = useTranslation()
  const {filterAmandement: filter} = useAppSelector(amandementSelector)
  const {options: citiesOptions, isLoading: isCitiesOptionsLoading} = useCities()
  const {options: regionOptions, isLoading: isRegionOptionsLoading} = useRegions()

  const handleChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterAmandement({...filter, ...value}))
  }

  return (
    <TRowFilter>
      <td>
        <div></div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('order-no')}
          value={filter?.po_number ?? ''}
          onChange={({target}) => handleChange({po_number: target.value})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('order-tanggal')}
          isSelectsRange={false}
          startDate={filter?.created_at ?? ''}
          onChange={({startDate}) => handleChange({created_at: startDate})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('order-pelanggan')}
          value={filter?.customer_name ?? ''}
          onChange={({target}) => handleChange({customer_name: target.value})}
        />
      </td>
      <td>
        <Selection
          data={REGARDING_OPTIONS}
          placeholder={t('order-perihal')}
          value={filter?.regarding ?? ''}
          onChange={(value: any) => handleChange({regarding: value})}
          formSelectProps={{disabled: true}}
        />
      </td>
      <td>
        <Selection
          data={SECTOR_OPTIONS}
          placeholder={t('Sektor')}
          value={filter?.sector_id ?? ''}
          onChange={(value: any) => handleChange({sector_id: value})}
        />
      </td>
      <td>
        <Select
          placeholder={t('sub-order-provinsi')}
          options={regionOptions}
          isLoading={isRegionOptionsLoading}
          isClearable
          onChange={(value: any) => handleChange({province: value?.value ?? ''})}
          menuPortalTarget={document.body}
          styles={{
            container: (base: any) => ({...base, padding: '0 !important'}),
            menuPortal: (base: any) => ({...base, zIndex: 1000}),
            control: (base: any) => ({
              ...base,
              color: 'black',
              borderWidth: 2,
              borderRadius: 6,
              borderColor: '#d9dce4',
              textAlign: 'left',
            }),
          }}
        />
      </td>
      <td>
        <Select
          placeholder={t('sub-order-kota')}
          options={citiesOptions}
          isLoading={isCitiesOptionsLoading}
          isClearable
          onChange={(value: any) => handleChange({city: value?.value ?? ''})}
          menuPortalTarget={document.body}
          styles={{
            container: (base: any) => ({...base, padding: '0 !important'}),
            menuPortal: (base: any) => ({...base, zIndex: 1000}),
            control: (base: any) => ({
              ...base,
              color: 'black',
              borderWidth: 2,
              borderRadius: 6,
              borderColor: '#d9dce4',
              textAlign: 'left',
            }),
          }}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('sub-order-produk')}
          value={filter?.product_name ?? ''}
          onChange={({target}) => handleChange({product_name: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Total Kuantum')}
          value={filter?.total_left_quantum ?? ''}
          onChange={({target}) => handleChange({total_left_quantum: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Price')}
          value={filter?.total_left_price ?? ''}
          onChange={({target}) => handleChange({total_left_price: target.value})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Status')}
          data={[...ORDER_STATUS, {value: '92', label: 'Revisi Amandemen'}]}
          value={filter?.status ?? ''}
          onChange={(value: any) => handleChange({status: value})}
        />
      </td>
    </TRowFilter>
  )
}

export default React.memo(RowFilter)
